import { defineRule } from "vee-validate";
import * as AllRules from "@vee-validate/rules";

Object.keys(AllRules).forEach((rule) => {
  defineRule(rule, AllRules[rule]);
});

defineRule("email", (value) => {
  if (!value || !value.length) {
    return true;
  }

  if (/@([_\-\]?[a-zA-Z0-9]*)\.([A-Za-z]{2,})/g.test(value)) {
    return /^[A-Za-z0-9]([_\-\.]?[a-zA-Z0-9]*)*\+?([_\-\.]?[a-zA-Z0-9]*)*@([_\-\]?[a-zA-Z0-9]*)\.([A-Za-z]{2,})/g.test(
      value
    );
  }

  return false;
});

defineRule("not_included", (value, array, input_meta) => {
  if (!value || !value.length) {
    return true;
  }

  const input_name = input_meta.name;

  if (input_meta.form[input_name] === "") return true;

  return !array.includes(value);
});

defineRule("password", (value) => {
  if (!value || !value.length) {
    return true;
  }

  if (
    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_\.=+-]).{8,}$/.test(
      value
    )
  ) {
    return false;
  }

  return true;
});

defineRule("textOnly", (value) => {
  if (!value || !value.length) {
    return true;
  }

  if (!/^[a-zA-Z\u00C0-\u00FF\-\s]+$/.test(value)) {
    return false;
  }

  return true;
});

defineRule("match", (value, [confirm]) => {
  if (!value || !value.length) {
    return true;
  }

  return value === confirm;
});

defineRule("postalCode", (value) => {
  if (!value || !value.length) {
    return true;
  }

  return /^[0-9]{2,10}$/.test(value);
});

defineRule("vat", (value) => {
  if (!value || !value.length) {
    return true;
  }

  return /^FR[0-9]{11}$|^LU[0-9]{8}$|^BE[0-1][0-9]{9}$/.test(value);
});
